export default __webpack_public_path__ + "static/media/Bashar.6a97d20f.jpg";